module.exports = __webpack_public_path__ + "img/novelty-lang.9c6d6537.png";